<div class="d-flex justify-content-between align-items-center mb-3">
  <span class="h5 mb-0">Table</span>
  <div class="btn-group">
    <wm-modal-confirm
      #configureModal
      title="Configure Table"
      ngbTooltip="Configure Table"
      commandText="Save"
      [showButton]="true"
      [buttonClass]="'btn'"
      [showButtonText]="true"
      [btnIcon]="'settings'"
      [iconStyle]="{ fontSize: '18px' }"
      [enabled]="!_workflowSvc.saving"
    >
      <!-- Table-level conditional visibility -->
      <div class="card card-body mb-3">
        <div class="row">
          <div class="col">
            <div class="switch">
              <label>
                <input
                  type="checkbox"
                  [(ngModel)]="showConditionalVisible"
                  (ngModelChange)="visibleConditionChanged()"
                />
                Conditionally Visible (entire table)
              </label>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="showConditionalVisible">
          <div class="col">
            <div class="row mt-3">
              <div class="col-11">
                <h6>Show table if criteria is true</h6>
              </div>
            </div>
            <wm-condition-group
              *ngIf="conditionSources && layout.visibleCriteria"
              [conditionSources]="conditionSources"
              [group]="layout.visibleCriteria.group"
              (conditionChanges)="visibleCriteriaChanged(layout.visibleCriteria.group)"
            ></wm-condition-group>
          </div>
        </div>
      </div>

      <div *ngIf="!layout.rows.length" class="text-muted mb-2">
        No rows defined. Click "+ Row" to add the first row.
      </div>

      <div class="table-responsive mb-3" *ngIf="layout.rows.length">
        <table class="table table-sm table-bordered align-middle mb-0">
          <tbody>
            <tr
              *ngFor="let row of layout.rows; let r = index; trackBy: trackRow"
              class="table-row"
            >
              <!-- Row-level drop list for cell drag-drop -->
              <td colspan="100%" class="p-0">
                <div
                  cdkDropList
                  [id]="getRowId(r)"
                  [cdkDropListData]="row.cells"
                  [cdkDropListConnectedTo]="getConnectedRowIds()"
                  [cdkDropListOrientation]="'horizontal'"
                  (cdkDropListDropped)="dropCell($event)"
                  class="cell-row-container"
                >
                  <!-- Individual draggable cells and placeholders -->
                  <div
                    *ngFor="
                      let cellWrapper of getCellsWithPlaceholders(r);
                      let c = index;
                      trackBy: trackCell
                    "
                    [class.draggable-cell]="!cellWrapper.isPlaceholder"
                    [class.placeholder-cell]="cellWrapper.isPlaceholder"
                    [cdkDrag]="!cellWrapper.isPlaceholder"
                    [cdkDragData]="cellWrapper.cell"
                  >
                    <!-- Placeholders for rowspan and dynamic columns -->
                    <div *ngIf="cellWrapper.isPlaceholder"
                         [class.rowspan-placeholder]="cellWrapper.placeholderType === 'rowspan'"
                         [class.dynamic-column-placeholder]="cellWrapper.placeholderType === 'dynamic-column'">

                      <!-- Rowspan placeholder -->
                      <div *ngIf="cellWrapper.placeholderType === 'rowspan'" class="placeholder-content">
                        <i class="material-icons">arrow_upward</i>
                        <small>Spanned</small>
                      </div>

                      <!-- Dynamic column placeholder -->
                      <div *ngIf="cellWrapper.placeholderType === 'dynamic-column'" class="placeholder-content">
                        <!-- Radio button icon -->
                        <ng-container *ngIf="cellWrapper.cell?.entity && cellWrapper.cell.entity.controlType?.toString().toLowerCase() === 'radio'">
                          <i class="material-icons">radio_button_unchecked</i>
                        </ng-container>
                        <!-- Checkbox icon -->
                        <ng-container *ngIf="!cellWrapper.cell?.entity || cellWrapper.cell.entity.controlType?.toString().toLowerCase() !== 'radio'">
                          <i class="material-icons">check_box_outline_blank</i>
                        </ng-container>
                        <small>{{ cellWrapper.listItem?.text || cellWrapper.listItem?.value || 'Item' }}</small>
                      </div>
                    </div>

                    <!-- Regular cell (not placeholder) -->
                    <ng-container *ngIf="!cellWrapper.isPlaceholder">
                    <!-- Assign local variable using the cell from wrapper -->
                    <ng-container *ngIf="cellWrapper.cell; let cell">
                    <!-- Cell drag handle -->
                    <div class="cell-drag-handle" cdkDragHandle>
                      <i class="material-icons">drag_indicator</i>
                    </div>

                    <!-- Cell content -->
                    <div class="cell-content">
                      <div
                        class="d-flex justify-content-between align-items-center mb-1"
                      >
                        <small class="text-uppercase text-muted">{{
                          cell.type
                        }}</small>
                        <button
                          type="button"
                          class="btn p-0"
                          [disabled]="cellHasSystemEntity(cell)"
                          [title]="cellHasSystemEntity(cell) ? 'Cannot remove cell: contains a system entity' : 'Remove cell'"
                          (click)="removeCell(row, getCellIndexInRow(row, cell))"
                        >
                          <i class="material-icons">delete</i>
                        </button>
                      </div>

                      <ng-container [ngSwitch]="cell.type">
                        <div *ngSwitchCase="'text'">
                          <input
                            type="text"
                            class="form-control form-control-sm mb-2"
                            [(ngModel)]="cell.staticText"
                            (ngModelChange)="onCellUpdated()"
                            placeholder="Static text"
                          />
                          <div class="d-flex align-items-center mb-2">
                            <label class="form-label mb-0 me-2 small">ColSpan:</label>
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              [(ngModel)]="cell.colspan"
                              (ngModelChange)="onCellUpdated()"
                              min="1"
                              max="10"
                              style="width: 60px;"
                              title="Number of columns to span"
                            />
                          </div>
                          <div class="d-flex align-items-center">
                            <label class="form-label mb-0 me-2 small">RowSpan:</label>
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              [(ngModel)]="cell.rowSpan"
                              (ngModelChange)="onCellUpdated()"
                              min="1"
                              max="10"
                              style="width: 60px;"
                              title="Number of rows to span"
                            />
                          </div>
                          <div class="d-flex align-items-center mt-2">
                            <label class="form-label mb-0 me-2 small">Color:</label>
                            <input
                              type="color"
                              class="form-control form-control-sm"
                              [(ngModel)]="cell.backgroundColor"
                              (ngModelChange)="onCellUpdated()"
                              style="width: 50px; height: 30px; padding: 2px;"
                              title="Background color"
                            />
                            <input
                              type="text"
                              class="form-control form-control-sm ms-2"
                              [(ngModel)]="cell.backgroundColor"
                              (ngModelChange)="onCellUpdated()"
                              placeholder="#RRGGBB"
                              style="width: 90px;"
                              title="Hex color code"
                            />
                            <button
                              *ngIf="cell.backgroundColor"
                              type="button"
                              class="btn btn-sm btn-outline-secondary ms-1"
                              (click)="cell.backgroundColor = null; onCellUpdated()"
                              title="Clear color"
                            >
                              <i class="material-icons" style="font-size: 14px;">clear</i>
                            </button>
                          </div>
                        </div>
                        <div
                          *ngSwitchCase="'entity'"
                          class="entity-cell-container"
                          cdkDropList
                          [id]="getCellId(r, c)"
                          [cdkDropListData]="cell"
                          [cdkDropListConnectedTo]="getConnectedCellIds()"
                          (cdkDropListDropped)="drop($event)"
                        >
                          <wm-activity-details-modal
                            *ngIf="newDEForm && !cell.entity"
                            [title]="
                              activity.model.screenName + ' - New Data Entity'
                            "
                            btnText="Add New Data Entity"
                            moduleId="modal-new-entity"
                            btnClass="btn btn-primary"
                            [form]="newDEForm"
                            (saved)="saveNew(cell)"
                            (canceled)="cancelNew(cell)"
                            (opened)="loadEditor(cell)"
                            [disabled]="
                              _workflowSvc.designerVersionMode || _workflowSvc.saving
                            "
                          >
                            <wm-data-entity-editor
                              *ngIf="cell.showEditor"
                              #newDEEditor
                              [workflow]="workflow || _context.workflow"
                              [activity]="activity"
                              [form]="newDEForm"
                            ></wm-data-entity-editor>
                          </wm-activity-details-modal>
                          <div
                            *ngIf="!cell.entity && getAvailableActivityEntities().length > 0"
                            ngbDropdown
                            class="d-inline-block"
                          >
                            <button
                              type="button"
                              class="btn mr-0 btn-raised btn-primary"
                              ngbDropdownToggle
                              [disabled]="_workflowSvc.designerVersionMode || _workflowSvc.saving"
                            >
                              Add Data Entity From Activity
                            </button>
                            <div ngbDropdownMenu>
                              <button
                                type="button"
                                ngbDropdownItem
                                *ngFor="
                                  let availableEntity of getAvailableActivityEntities();
                                  trackBy: trackAvailableEntity
                                "
                                (click)="addExistingEntity(cell, availableEntity)"
                              >
                                {{ availableEntity.label || availableEntity.templateCode }}
                              </button>
                            </div>
                          </div>
                          <div
                            *ngIf="cell.entity"
                            class="draggable-entity"
                            cdkDrag
                            [cdkDragData]="cell"
                            [cdkDragDisabled]="!canDragCell(cell)"
                          >
                            <div class="drag-handle" cdkDragHandle>
                              <i class="material-icons">drag_handle</i>
                            </div>
                            <wm-data-entity-item
                              [de]="{ entity: cell.entity }"
                              [workflow]="workflow"
                              [activity]="activity"
                              (deleteEntity)="removeDataEntity(cell)"
                              (editEntity)="
                                viewDataEntity(row, cell, cell.entity)
                              "
                              (saveEntity)="saveDataEntity(cell, $event)"
                            >
                            </wm-data-entity-item>
                          </div>
                          <div
                            *ngIf="cell.entity && cell.entity.isSystemEntity"
                            class="mt-2"
                          >
                            <button
                              type="button"
                              class="btn mr-0 btn-raised btn-primary"
                              (click)="moveEntityBackToActivity(cell)"
                              [disabled]="_workflowSvc.designerVersionMode || _workflowSvc.saving"
                            >
                              Move Back to Original Position
                            </button>
                          </div>
                          <div
                            *ngIf="!cell.entity"
                            class="empty-cell-placeholder"
                          >
                            Drop entity here or add new
                          </div>
                          <!-- ColSpan and RowSpan configuration for entity cells -->
                          <div class="d-flex align-items-center mt-2 mb-2">
                            <label class="form-label mb-0 me-2 small">ColSpan:</label>
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              [(ngModel)]="cell.colspan"
                              (ngModelChange)="onCellUpdated()"
                              min="1"
                              max="10"
                              style="width: 60px;"
                              title="Number of columns to span"
                            />
                          </div>
                          <div class="d-flex align-items-center mt-2">
                            <label class="form-label mb-0 me-2 small">RowSpan:</label>
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              [(ngModel)]="cell.rowSpan"
                              (ngModelChange)="onCellUpdated()"
                              min="1"
                              max="10"
                              style="width: 60px;"
                              title="Number of rows to span"
                            />
                          </div>
                          <div class="d-flex align-items-center mt-2">
                            <label class="form-label mb-0 me-2 small">Color:</label>
                            <input
                              type="color"
                              class="form-control form-control-sm"
                              [(ngModel)]="cell.backgroundColor"
                              (ngModelChange)="onCellUpdated()"
                              style="width: 50px; height: 30px; padding: 2px;"
                              title="Background color"
                            />
                            <input
                              type="text"
                              class="form-control form-control-sm ms-2"
                              [(ngModel)]="cell.backgroundColor"
                              (ngModelChange)="onCellUpdated()"
                              placeholder="#RRGGBB"
                              style="width: 90px;"
                              title="Hex color code"
                            />
                            <button
                              *ngIf="cell.backgroundColor"
                              type="button"
                              class="btn btn-sm btn-outline-secondary ms-1"
                              (click)="cell.backgroundColor = null; onCellUpdated()"
                              title="Clear color"
                            >
                              <i class="material-icons" style="font-size: 14px;">clear</i>
                            </button>
                          </div>
                          <!-- List Data Entity Dynamic Columns Option -->
                          <div *ngIf="isListDataEntity(cell.entity)" class="mt-2">
                            <div class="form-check">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="dynamicColumns-{{r}}-{{c}}"
                                [(ngModel)]="cell.renderListItemsAsDynamicColumns"
                                (ngModelChange)="onDynamicColumnsChanged(row, cell)"
                              />
                              <label class="form-check-label" for="dynamicColumns-{{r}}-{{c}}">
                                Render list items as dynamic columns
                              </label>
                            </div>
                            <small *ngIf="cell.renderListItemsAsDynamicColumns" class="text-muted d-block mt-1">
                              Each list item will create a separate cell with a radio/checkbox control.
                            </small>
                            <div *ngIf="getDynamicColumnsValidation(row, cell) as validation" class="mt-2">
                              <div *ngIf="validation.isValid" class="alert alert-success py-1 px-2 small">
                                <i class="material-icons" style="font-size: 14px; vertical-align: middle;">check_circle</i>
                                Will create {{validation.expectedColumns}} dynamic column(s)
                              </div>
                              <div *ngIf="!validation.isValid" class="alert alert-warning py-1 px-2 small">
                                <i class="material-icons" style="font-size: 14px; vertical-align: middle;">warning</i>
                                {{validation.message}}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div *ngSwitchCase="'layout'">
                          <!-- Layout type selector if no layout selected -->
                          <div *ngIf="!cell.layoutModel" class="mb-2">
                            <label class="form-label mb-1 small">Select Layout Type:</label>
                            <div class="btn-group-vertical w-100">
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-primary"
                                (click)="addLayoutModel(cell, 'table-data-entity-layout')"
                                title="Add table layout"
                              >
                                <i class="material-icons">table_chart</i> Table
                              </button>
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-primary"
                                (click)="addLayoutModel(cell, 'group-data-entity-layout')"
                                title="Add group layout"
                              >
                                <i class="material-icons">folder</i> Group
                              </button>
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-primary"
                                (click)="addLayoutModel(cell, 'row-data-entity-layout')"
                                title="Add row layout"
                              >
                                <i class="material-icons">view_week</i> Row
                              </button>
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-primary"
                                (click)="addLayoutModel(cell, 'default-data-entity-layout')"
                                title="Add entity layout"
                              >
                                <i class="material-icons">input</i> Entity
                              </button>
                            </div>
                          </div>

                          <!-- Display the appropriate layout editor -->
                          <div *ngIf="cell.layoutModel">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                              <small class="badge bg-secondary">{{ cell.layoutModel.type }}</small>
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-danger"
                                (click)="removeLayoutModel(cell)"
                                title="Remove layout"
                              >
                                <i class="material-icons">clear</i>
                              </button>
                            </div>

                            <!-- Table Layout Editor -->
                            <wm-data-entity-table-layout-editor
                              *ngIf="cell.layoutModel.type === 'table-data-entity-layout'"
                              [layout]="cell.layoutModel"
                              [workflow]="workflow"
                              [activity]="activity"
                              [form]="form"
                              (layoutChanged)="onLayoutChanged(cell, $event)"
                            ></wm-data-entity-table-layout-editor>

                            <!-- Group Layout Editor -->
                            <wm-data-entity-group-layout-editor
                              *ngIf="cell.layoutModel.type === 'group-data-entity-layout'"
                              [layout]="cell.layoutModel"
                              [workflow]="workflow"
                              [activity]="activity"
                              [form]="form"
                            ></wm-data-entity-group-layout-editor>

                            <!-- Row Layout Editor -->
                            <wm-data-entity-row-layout-editor
                              *ngIf="cell.layoutModel.type === 'row-data-entity-layout'"
                              [layout]="cell.layoutModel"
                              [workflow]="workflow"
                              [activity]="activity"
                              [form]="form"
                            ></wm-data-entity-row-layout-editor>

                            <!-- Default Entity Layout Editor -->
                            <div *ngIf="cell.layoutModel.type === 'default-data-entity-layout'">
                              <wm-activity-details-modal
                                *ngIf="newDEForm && !cell.layoutModel.entity"
                                [title]="activity.model.screenName + ' - New Data Entity'"
                                btnText="Add New Data Entity"
                                moduleId="modal-new-entity-layout"
                                btnClass="btn btn-primary btn-sm"
                                [form]="newDEForm"
                                (saved)="cell.layoutModel.entity = newDEEditor.dataEntity; onLayoutChanged(cell, null)"
                                (canceled)="cell.showEditor = false"
                                (opened)="cell.showEditor = true"
                              >
                                <wm-data-entity-editor
                                  *ngIf="cell.showEditor"
                                  #newDEEditor
                                  [workflow]="workflow || _context.workflow"
                                  [activity]="activity"
                                  [form]="newDEForm"
                                ></wm-data-entity-editor>
                              </wm-activity-details-modal>

                              <wm-data-entity-item
                                *ngIf="cell.layoutModel.entity"
                                [de]="{ entity: cell.layoutModel.entity }"
                                [workflow]="workflow"
                                [activity]="activity"
                                (deleteEntity)="cell.layoutModel.entity = null; onLayoutChanged(cell, null)"
                                (editEntity)="cell.showEditor = true"
                                (saveEntity)="cell.layoutModel.entity = $event; onLayoutChanged(cell, null)"
                              ></wm-data-entity-item>
                            </div>
                          </div>

                          <!-- ColSpan and RowSpan configuration for layout cells -->
                          <div class="d-flex align-items-center mt-2 mb-2">
                            <label class="form-label mb-0 me-2 small">ColSpan:</label>
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              [(ngModel)]="cell.colspan"
                              (ngModelChange)="onCellUpdated()"
                              min="1"
                              max="10"
                              style="width: 60px;"
                              title="Number of columns to span"
                            />
                          </div>
                          <div class="d-flex align-items-center mt-2">
                            <label class="form-label mb-0 me-2 small">RowSpan:</label>
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              [(ngModel)]="cell.rowSpan"
                              (ngModelChange)="onCellUpdated()"
                              min="1"
                              max="10"
                              style="width: 60px;"
                              title="Number of rows to span"
                            />
                          </div>
                          <div class="d-flex align-items-center mt-2">
                            <label class="form-label mb-0 me-2 small">Color:</label>
                            <input
                              type="color"
                              class="form-control form-control-sm"
                              [(ngModel)]="cell.backgroundColor"
                              (ngModelChange)="onCellUpdated()"
                              style="width: 50px; height: 30px; padding: 2px;"
                              title="Background color"
                            />
                            <input
                              type="text"
                              class="form-control form-control-sm ms-2"
                              [(ngModel)]="cell.backgroundColor"
                              (ngModelChange)="onCellUpdated()"
                              placeholder="#RRGGBB"
                              style="width: 90px;"
                              title="Hex color code"
                            />
                            <button
                              *ngIf="cell.backgroundColor"
                              type="button"
                              class="btn btn-sm btn-outline-secondary ms-1"
                              (click)="cell.backgroundColor = null; onCellUpdated()"
                              title="Clear color"
                            >
                              <i class="material-icons" style="font-size: 14px;">clear</i>
                            </button>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    </ng-container><!-- Close cell aliasing -->
                    </ng-container><!-- Close !isPlaceholder check -->
                  </div>

                  <!-- Row action buttons -->
                  <div class="row-actions">
                    <div class="btn-group-vertical mb-2">
                      <!-- Row color picker -->
                      <div class="d-flex align-items-center mb-2">
                        <label class="form-label mb-0 me-1 small" style="font-size: 10px;">Row:</label>
                        <input
                          type="color"
                          class="form-control form-control-sm"
                          [(ngModel)]="row.backgroundColor"
                          (ngModelChange)="onCellUpdated()"
                          style="width: 35px; height: 25px; padding: 1px;"
                          title="Row background color"
                        />
                        <button
                          *ngIf="row.backgroundColor"
                          type="button"
                          class="btn btn-sm btn-outline-secondary ms-1 p-0"
                          (click)="row.backgroundColor = null; onCellUpdated()"
                          style="width: 20px; height: 20px;"
                          title="Clear row color"
                        >
                          <i class="material-icons" style="font-size: 12px;">clear</i>
                        </button>
                      </div>
                    </div>
                    <div class="btn-group-vertical">
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm"
                        (click)="addCell(row, 'text')"
                        title="Add text cell"
                      >
                        Txt
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm"
                        (click)="addCell(row, 'entity')"
                        title="Add entity cell"
                      >
                        Ent
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm"
                        (click)="addCell(row, 'layout')"
                        title="Add layout cell"
                      >
                        Lay
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm"
                        [class.active]="rowShowConditionalVisible(row)"
                        (click)="setRowShowConditionalVisible(row, !rowShowConditionalVisible(row))"
                        title="Configure conditional visibility for this row"
                      >
                        <i class="material-icons" style="font-size: 14px;">visibility</i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm"
                        (click)="removeRow(r)"
                        [disabled]="rowHasSystemEntity(row)"
                        [title]="rowHasSystemEntity(row) ? 'Cannot remove row: contains a system entity' : 'Remove row'"
                      >
                        <i class="material-icons">delete</i>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Row-level conditional visibility editor -->
                <div class="card card-body mt-2" *ngIf="rowShowConditionalVisible(row)">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h6 class="mb-0">Row {{ r + 1 }} — Show if criteria is true</h6>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-secondary"
                      (click)="setRowShowConditionalVisible(row, false)"
                      title="Disable conditional visibility for this row"
                    >
                      <i class="material-icons" style="font-size: 14px;">clear</i>
                    </button>
                  </div>
                  <wm-condition-group
                    *ngIf="conditionSources && row.visibleCriteria"
                    [conditionSources]="conditionSources"
                    [group]="row.visibleCriteria.group"
                    (conditionChanges)="rowVisibleCriteriaChanged(row, row.visibleCriteria.group)"
                  ></wm-condition-group>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mb-3">
        <button
          type="button"
          class="btn btn-sm btn-outline-primary"
          (click)="addRow()"
        >
          <i class="fa fa-plus"></i> Add Row
        </button>
      </div>
    </wm-modal-confirm>
  </div>
</div>
